
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Toast } from 'vant';
import PopupShell from './PopupShell.vue';
import ConfirmButton from './ConfirmButton.vue';
import header from '../assets/popup-header-phone.png';

/** 绑定手机号弹窗 */
@Component({
  components: { PopupShell, ConfirmButton },
})
export default class BindPhonePopup extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;

  header = header;
  phone = '';

  @Watch('value')
  onVisible(visible: boolean) {
    if (visible) this.phone = '';
  }

  onConfirm() {
    if (!/^1\d{10}$/.test(this.phone)) {
      Toast('请输入正确的手机号码');
      return;
    }
    this.$emit('confirm', this.phone);
  }
}
